// Agmarknet commodity + mandi → Hindi dictionary, crop emoji + curated royalty-free images.
// Keyword-based matcher so Agmarknet's messy names ("Bengal Gram(Gram)(Whole)") still resolve.

const IMG = {
  wheat: "https://images.unsplash.com/photo-1529511582893-2d7e684dd128?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  soybean: "https://images.unsplash.com/photo-1572457224112-06d191bb6d01?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  garlic: "https://images.pexels.com/photos/29640700/pexels-photo-29640700.jpeg?auto=compress&cs=tinysrgb&w=400",
  onion: "https://images.unsplash.com/photo-1580201092675-a0a6a6cafbb1?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  tomato: "https://images.unsplash.com/photo-1582284540020-8acbe03f4924?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  maize: "https://images.unsplash.com/photo-1554402100-8d1d9f3dff80?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  cotton: "https://images.unsplash.com/photo-1761069183527-a1a1414ee71f?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  chickpea: "https://images.unsplash.com/photo-1644432757699-bb5a01e8fb0e?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
};

// [matchKeywords[], Hindi, emoji, imgKey]
const COMMODITY = [
  [["wheat", "gehu"], "गेहूँ", "🌾", "wheat"],
  [["soybean", "soyabean", "soya"], "सोयाबीन", "🫘", "soybean"],
  [["garlic", "lahsun"], "लहसुन", "🧄", "garlic"],
  [["onion", "pyaz"], "प्याज़", "🧅", "onion"],
  [["tomato", "tamatar"], "टमाटर", "🍅", "tomato"],
  [["maize", "corn"], "मक्का", "🌽", "maize"],
  [["cotton", "kapas"], "कपास", "🌱", "cotton"],
  [["bengal gram", "chana", "gram"], "चना", "🫛", "chickpea"],
  [["kabuli"], "काबुली चना", "🫛", "chickpea"],
  [["black gram", "urd"], "उड़द", "🫘", null],
  [["green gram", "moong"], "मूँग", "🫛", null],
  [["red gram", "arhar", "tur"], "अरहर (तूर)", "🫘", null],
  [["lentil", "masur"], "मसूर", "🫘", null],
  [["sesam", "til", "gingelly"], "तिल", "🌰", null],
  [["mustard", "sarson", "rai"], "सरसों", "🌼", null],
  [["linseed", "flax"], "अलसी", "🌱", null],
  [["groundnut", "peanut"], "मूँगफली", "🥜", null],
  [["coriander", "dhania"], "धनिया", "🌿", null],
  [["cumin", "jeera"], "जीरा", "🌱", null],
  [["fennel", "saunf"], "सौंफ", "🌿", null],
  [["fenugreek", "methi"], "मेथी", "🌿", null],
  [["potato", "aloo"], "आलू", "🥔", null],
  [["chilli", "mirch"], "मिर्च", "🌶️", null],
  [["paddy", "dhan", "rice"], "धान", "🌾", null],
  [["barley", "jau"], "जौ", "🌾", null],
  [["guar"], "ग्वार", "🌱", null],
  [["ashwagandha"], "अश्वगंधा", "🌿", null],
  [["isabgol", "psyllium"], "इसबगोल", "🌿", null],
  [["cauliflower"], "फूलगोभी", "🥦", null],
  [["cabbage"], "पत्तागोभी", "🥬", null],
  [["brinjal", "eggplant"], "बैंगन", "🍆", null],
  [["banana"], "केला", "🍌", null],
  [["apple"], "सेब", "🍎", null],
  [["sugarcane", "ganna"], "गन्ना", "🎋", null],
  [["turmeric", "haldi"], "हल्दी", "🌿", null],
  [["ginger", "adrak"], "अदरक", "🫚", null],
  [["peas", "matar"], "मटर", "🫛", null],
];

const MANDI = [
  [["neemuch"], "नीमच"], [["mandsaur"], "मंदसौर"], [["indore"], "इंदौर"], [["ratlam"], "रतलाम"],
  [["ujjain"], "उज्जैन"], [["dewas"], "देवास"], [["ratlam"], "रतलाम"], [["jaora"], "जावरा"],
  [["shamgarh"], "शामगढ़"], [["petlawad"], "पेटलावद"], [["kalapipal"], "कालापीपल"], [["sanawad"], "सनावद"],
  [["dhar"], "धार"], [["khargone"], "खरगोन"], [["bhopal"], "भोपाल"], [["jabalpur"], "जबलपुर"],
  [["sagar"], "सागर"], [["vidisha"], "विदिशा"], [["sehore"], "सीहोर"], [["harda"], "हरदा"],
  [["datia"], "दतिया"], [["guna"], "गुना"], [["shajapur"], "शाजापुर"], [["ashoknagar"], "अशोकनगर"],
  [["betul"], "बैतूल"], [["chhindwara"], "छिंदवाड़ा"], [["khandwa"], "खंडवा"], [["badnawar"], "बदनावर"],
];

const norm = (s) => (s || "").toLowerCase();

function match(list, name) {
  const n = norm(name);
  for (const row of list) {
    if (row[0].some((k) => n.includes(k))) return row;
  }
  return null;
}

// Clean the trailing "APMC"/"F&V" etc from mandi names for matching + display
export function hiMandi(name, language) {
  if (!name) return name;
  const base = name.replace(/\s*(apmc|mandi|\(f&v\)|f&v)\s*$/i, "").trim();
  if (language === "हिंदी") {
    const m = match(MANDI, base);
    if (m) return m[1] + " मंडी";
  }
  return name;
}

export function hiCommodity(name, language) {
  if (language !== "हिंदी") return name;
  const m = match(COMMODITY, name);
  return m ? m[1] : name;
}

// display: Hindi (localName) or English depending on language; returns {main, sub, emoji, img}
export function commodityDisplay(name, language) {
  const m = match(COMMODITY, name);
  const hi = m ? m[1] : name;
  const en = name;
  return {
    main: language === "हिंदी" ? hi : en,
    sub: language === "हिंदी" ? en : (m ? m[1] : ""),
    emoji: m ? m[2] : "🌱",
    img: m && m[3] ? IMG[m[3]] : null,
  };
}

// fuzzy match: does commodity/mandi match a query in either script?
export function matchesQuery(commodity, market, q) {
  if (!q) return true;
  const s = q.toLowerCase();
  const cm = match(COMMODITY, commodity);
  const mm = match(MANDI, (market || "").replace(/\s*(apmc|mandi)\s*$/i, "").trim());
  const hay = [commodity, market, cm ? cm[1] : "", mm ? mm[1] : ""].join(" ").toLowerCase();
  return hay.includes(s);
}
